import VerticalOptionsMenu from './VerticalOptionsMenu.js';

export default class YesOrNoMenu extends VerticalOptionsMenu {
    constructor() {
        super({ options: ['Yes', 'No'] });
    }

    yes() {
        return this.getCurrentOptionValue() === 'Yes';
    }

    no() {
        return this.getCurrentOptionValue() === 'No';
    }
}
